module.exports = __webpack_public_path__ + "static/media/tapleyjung2.883e05e4.ogg";